import React from 'react';
var defaultValue = {
  debug: function debug() {},
  locales: [],
  merge: Object.assign,
  messages: {},
  pathSep: '.'
};
var context = React.createContext(defaultValue);
export { context as default, defaultValue };